import './FloatingTextField.scss';

const FloatingTextField = ({
  id = '',
  label = '',
  value = '',
  type = 'text',
  noFloating = false,
  disabled = false,
  onChange = (e) => {},
}) => {
  if (!noFloating) {
    return (
      <div className="form-group">
        <input
          type={type}
          id={id}
          className="form-control"
          required
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <label className="form-control-placeholder" htmlFor={id}>{label}</label>
      </div>
    );
  }

  return (
    <div className="form-group">
      <input
        type={type}
        id={id}
        className="form-control"
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <label className="form-control-placeholder" htmlFor={id}>{label}</label>
    </div>
  );
};

export default FloatingTextField;
